<div class="message-popup-wrapper bulk-pod-dialog">
  <div class="message-popup-header">
    <div class="ibc-body-text-large-bold">{{ dialogTitle }}</div>
    <div class="card-action-icons">
      <app-svg-icon
        [iconName]="'close'"
        class="cursor"
        [isStaticSvg]="true"
        [isFrom]="'Popup'"
        (staticIconClicked)="onCancel()">
      </app-svg-icon>
    </div>
  </div>

  <div class="message-popup-content" [formGroup]="form">
    <mat-form-field appearance="outline" class="mat-md bulk-pod-form-fields">
      <mat-label>Driver Name</mat-label>
      <input
        matInput
        formControlName="driverName"
        [maxlength]="nameMaxLength" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="mat-md bulk-pod-form-fields">
      <mat-label>Carrier Name / POD Name</mat-label>
      <input
        matInput
        formControlName="carrierName"
        [maxlength]="nameMaxLength" />
      <app-svg-icon
        *ngIf="checkControlHasError('carrierName')"
        matSuffix
        [iconName]="actionIcons.infoCircle"
        [isStaticSvg]="true"
        [isFrom]="svgIconFromList.page"
        class="cursor"
        (click)="fetchWidth($event, 'carrierName')"
        (keydown)="$event.stopPropagation()"></app-svg-icon>
      <app-custom-error-tooltip
        *ngIf="
          checkControlHasError('carrierName') &&
          setInfoErrorTooltip['carrierName']
        "
        [tooltipWidth]="setTooltipInfoWidth['carrierName']"
        [tooltipText]="getErrorMessage('carrierName')"
        (tooltipCloseClicked)="
          commonService.closeErrorTooltip('carrierName', setInfoErrorTooltip)
        ">
      </app-custom-error-tooltip>
    </mat-form-field>

    <mat-form-field appearance="outline" class="mat-md bulk-pod-form-fields">
      <mat-label>{{ dateTimeLabel }}</mat-label>
      <!-- FR-BPM-UI-020/021: typeable; Manifest locks the time zone (AC1, AC6). -->
      <app-date-time-picker
        #podDateTimePicker
        formControlName="dateTimeAndTimezone"
        placeholder="MM/dd/yyyy HH:mm:ss"
        [timeZones]="timeZones"
        [allowTyping]="true"
        [lockTimeZone]="isManifest">
      </app-date-time-picker>
      <app-svg-icon
        *ngIf="!form.get('dateTimeAndTimezone')?.disabled"
        matSuffix
        role="button"
        tabindex="0"
        aria-label="Open calendar"
        class="cursor pod-date-time-toggle"
        [iconName]="actionIcons.datePicker"
        [isStaticSvg]="true"
        [isFrom]="svgIconFromList.page"
        (click)="podDateTimePicker.openPicker($event)"
        (keydown.enter)="podDateTimePicker.openPicker($event)"></app-svg-icon>
      <app-svg-icon
        *ngIf="checkControlHasError('dateTimeAndTimezone')"
        matSuffix
        [iconName]="actionIcons.infoCircle"
        [isStaticSvg]="true"
        [isFrom]="svgIconFromList.page"
        class="cursor"
        (click)="fetchWidth($event, 'dateTimeAndTimezone')"
        (keydown)="$event.stopPropagation()"></app-svg-icon>
      <app-custom-error-tooltip
        *ngIf="
          checkControlHasError('dateTimeAndTimezone') &&
          setInfoErrorTooltip['dateTimeAndTimezone']
        "
        [tooltipWidth]="setTooltipInfoWidth['dateTimeAndTimezone']"
        [tooltipText]="getErrorMessage('dateTimeAndTimezone')"
        (tooltipCloseClicked)="
          commonService.closeErrorTooltip(
            'dateTimeAndTimezone',
            setInfoErrorTooltip
          )
        ">
      </app-custom-error-tooltip>
    </mat-form-field>

    <mat-form-field
      *ngIf="isDetailsMode && podDescription"
      appearance="outline"
      class="mat-md bulk-pod-form-fields">
      <mat-label>Additional Details</mat-label>
      <textarea
        matInput
        [value]="podDescription"
        [readonly]="true"
        rows="2"></textarea>
    </mat-form-field>
  </div>

  <div class="popup-footer">
    <button
      type="button"
      class="ibc-medium-button ibc-secondary-default-button cursor"
      (click)="onCancel()">
      <span class="ibc-body-text-regular">{{ popupButtons.Cancel }}</span>
    </button>
    <button
      type="button"
      class="ibc-medium-button ibc-primary-default-button"
      *ngIf="!readOnly"
      [ngClass]="canSave ? 'cursor' : ''"
      [disabled]="!canSave || isSubmitting"
      (click)="onSave()">
      <span class="ibc-body-text-regular">{{ saveButtonLabel }}</span>
    </button>
  </div>
</div>
